/*
* @Author: zhangzhitao
* @Date: 2019-06-14 13:44:49
* @Des:
 * @Last Modified by: zhenghong7
 * @Last Modified time: 2019-09-11 11:43:26
*/

<template>
  <div class="m-personal-page">
    <div class="m-main-ctn media-container">
      <div class="left-wrap">
        <div class="left-banner">
          <span>个人中心</span>
        </div>
        <div class="m-menu-wrap">
          <el-scrollbar wrap-class="m-wrap-scroll">
            <el-menu
              ref="menu"
              @select="onMenuSelect"
            >
              <template v-for="data in menus">
                <el-submenu
                  v-if="
                  !data.fullUrl&&data.children && data.children.length && data.isShow === 0
                "
                  :index="data.menuId"
                  :title="data.name"
                  :key="data.menuId"
                >
                  <img
                    class="icon"
                    slot="icon"
                    :src="data.iconInfo.path"
                    :onerror="defaultIcon"
                  />
                  <menu-item
                    v-for="(sub, index) in data.children"
                    :key="index"
                    :data="sub"
                  ></menu-item>
                </el-submenu>
                <el-menu-item
                  v-else-if="data.name !== '-' && data.isShow === 0"
                  :index="data.menuId"
                  :key="data.menuId"
                >
                  <template v-slot:icon>
                    <img
                      class="icon"
                      :onerror="defaultIcon"
                      :src="data.iconInfo.path"
                    />
                  </template>
                  <template v-slot:default>
                    {{ data.name }}
                  </template>
                </el-menu-item>
                <div
                  class="u-cut-line"
                  :key="data.id"
                  v-else
                ></div>
              </template>
            </el-menu>
          </el-scrollbar>
        </div>
      </div>
      <div class="right-wrap">
        <common-iframe
          :srcInfo="frameSrc"
          frameborder="0"
          class="frame"
        ></common-iframe>
      </div>
    </div>
  </div>
</template>

<script>
import commonIframe from '../view-page/common-iframe'
import menuItem from './menu-item'
import { ErrorHandleMixin, LoadingMixin } from 'utils/mixin'
import API from 'api/api'
export default {
  name: 'personal-page',
  data () {
    return {
      activeIndex: '1',
      frameSrc: '',
      defaultMenu: '',
      menus: [],
      menuMap: {},
      defaultIcon: `this.src="${require('../../assets/images/nav_icondefault_B.png')}"`
    }
  },
  watch: {
    defaultMenu (value) {
      this.$refs.menu.activeIndex = value
      this.frameSrc = this.menuMap[value].fullUrl
    }
  },
  components: { commonIframe, menuItem },

  computed: {},

  mounted () {
    this._getMenus()
  },

  methods: {
    getQuery () {
      // let data = this.$route.query
      let menuId = this.$storage.session.get(`portal-personal-${this.$store.state.userName}`)
      if (menuId) this.defaultMenu = menuId
    },
    onMenuSelect (menuId) {
      const _menu = this.menuMap[menuId]
      // this.$router.push({
      //   path: '/index/personal',
      //   query: { menuId: menuId }
      // })
      this.$storage.session.set(`portal-personal-${this.$store.state.userName}`, menuId)
      this.frameSrc = _menu.fullUrl
    },
    _getMenus () {
      let _loadingInstance = this._getLoading()
      API.menu
        .getPersonalMenu()
        .then(res => {
          _loadingInstance.close()
          this.menus = res.data
          this.menuMap = {}
          this.menus.forEach(item => {
            this._handleMenu(item, this.menuMap)
          })
          this.getQuery()
        })
        .catch(() => {
          _loadingInstance.close()
        })
    },
    _handleMenu (menu, map) {
      map[menu.menuId] = menu
      if (menu.children && menu.children.length) {
        menu.children.forEach(item => {
          this._handleMenu(item, map)
        })
      } else if (this.defaultMenu === '') {
        this.defaultMenu = menu.menuId
      }
    }
  },
  mixins: [ErrorHandleMixin, LoadingMixin]

}

</script>
<style lang="scss" scoped>
$type: screen;
$max: max-width;
$min: min-width;
$value1: 1760px;
$value2: 1480px;
$value3: 1280px;
.m-personal-page {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
  ::v-deep .m-wrap-scroll {
    position: absolute !important;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
  .m-main-ctn {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    &.media-container {
      width: 1720px;
      @media #{$type} and ($max: $value1) and ($min: $value2) {
        width: calc(100% - 40px);
      }
      @media #{$type} and ($max: $value2) {
        width: 100%;
      }
    }
    .left-wrap {
      float: left;
      width: 256px;
      height: 100%;
      @media #{$type} and ($max:$value3) {
        width: 160px;
      }
      .left-banner {
        width: 100%;
        height: 150px;
        background: url("../../assets/images/jx_personal_head.png");
        background-color: #fff;
        overflow: hidden;
        span {
          display: block;
          font-size: 28px;
          color: #ffffff;
          letter-spacing: 0;
          line-height: 42px;
          margin-top: 48px;
          margin-left: 28px;
          @media #{$type} and ($max:$value3) {
            margin-left: auto;
            margin-right: auto;
            text-align: center;
          }
        }
      }
      .m-menu-wrap {
        position: relative;
        width: 100%;
        height: calc(100% - 174px);
        padding-top: 24px;
        background: #fff;
        ::v-deep .m-wrap-scroll {
          position: absolute !important;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          .el-menu {
            background: #fff;
          }
          .el-menu-item {
            &:hover {
              background: rgba($color: #000, $alpha: 0.04);
            }
            &.is-active {
              background: rgba($color: #00b4b4, $alpha: 0.08);
            }
          }
          .el-submenu {
            &:hover {
              background: rgba($color: #000, $alpha: 0.04);
            }
            &.is-opened {
              background: rgba($color: #00b4b4, $alpha: 0.08);
            }
          }
        }
      }
    }
    .right-wrap {
      float: left;
      width: calc(100% - 280px);
      height: calc(100% - 60px);
      margin-left: 24px;
      margin-top: 36px;
      @media #{$type} and ($max:$value3) {
        width: calc(100% - 176px);
        margin-left: 16px;
        height: calc(100% - 48px);
        margin-top: 24px;
      }
    }
  }
}
</style>
